import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  width: 100%;
  position: absolute;
  justify-content: space-between;
`;

export const ContentContainer = styled.div`
  flex-grow: 9999;
`;
